/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Russian
export default {
  "'Goals.CreateGoal.footer.create-label": 'Создать',
  'Goals.CreateGoal.create.error': 'Не удалось создать цель',
  'Goals.CreateGoal.create.network.error': 'Ошибка подключения',
  'Goals.CreateGoal.create.permission.error': 'У вас нет необходимых прав для создания цели.',
  'Goals.CreateGoal.error.description': 'Произошла ошибка. Проверьте подключение к Интернету и повторите попытку.',
  'Goals.CreateGoal.error.header': 'Не удалось создать цель',
  'Goals.CreateGoal.footer.cancel-label': 'Отмена',
  'Goals.CreateGoal.form.icon.back-button-label': 'Назад',
  'Goals.CreateGoal.form.name.error': 'Укажите имя цели',
  'Goals.CreateGoal.form.name.label': 'Имя',
  'Goals.CreateGoal.form.owner.error': 'Укажите владельца.',
  'Goals.CreateGoal.header': 'Создать цель',
  'Goals.CreateGoal.parent-goal-label': 'Родительская цель',
  'Goals.CreateGoal.parent-goal.error': 'Укажите родительскую цель.',
  'Goals.CreateGoal.required-fields-are-marked': 'Обязательные поля отмечены звездочкой <asterisk></asterisk>',
  'Goals.CreateGoal.site-label': 'Сайт',
  'Goals.CreateGoal.type-label': 'Тип',
  'Goals.CreateGoal.type-label-placeholder': 'Как ее назвать?',
  'Goals.GoalCreationModal.label.date-selection-placeholder': 'Выберите дату',
  'Goals.GoalCreationModal.label.date-selection-title': 'Целевая дата',
  'Goals.GoalCreationModal.label.owner-picker-placeholder': 'Введите пользователя',
  'Goals.GoalCreationModal.label.owner-selection-title': 'Владелец',
  'townsquare.api.goal-type-description.goal': 'Любые цели',
  'townsquare.api.goal-type-description.key-result': 'Количественный способ измерения цели (модель OKR).',
  'townsquare.api.goal-type-description.objective': 'Результат, которого вы хотите достичь (модель OKR).',
};
